import { render, staticRenderFns } from "./Pill.vue?vue&type=template&id=5d863f13&"
import script from "./Pill.js?vue&type=script&lang=js&"
export * from "./Pill.js?vue&type=script&lang=js&"
import style0 from "./Pill.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports